/*
*###############################################################################
*Module Name                   : PasswordReset.js                              #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : I Dinisuru Balasuriya                         #
*Date                          : Tuesday, June 4th 2024, 09:49:55 am           #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState, useEffect, useContext } from 'react'
import { MetaTags } from 'react-meta-tags'
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
    Alert,
    TabContent,
    TabPane,
} from 'reactstrap'

//**Importing required componant files   */
import Breadcrumb from 'components/Common/Breadcrumb'
import DPTopToolBar from 'framework/widgets/DPTopToolBar'
import { Text } from "../../../framework/validators/TextValidation"
import DPAlert from "../../../framework/widgets/DPAlert"
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import DPPermission from "framework/widgets/DPPermission"
import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';
import DPPrintOption from 'framework/widgets/DPPrintOptions'
import PasswordResetContent from './PasswordResetContent'
import { GetAllUserData } from '../User-Master/UserMasterController'
import { Unlock_User, Update_User_Password } from './PasswordResetController'
import DPNavBar from 'framework/widgets/DPNavBar'
import { UnlockUserContent } from './UnlockUserContent'


//**End Importing required componant files */

const PasswordReset = (props) => {

    let history = useHistory();
    var time = process.env.REACT_APP_ALERTTIMEOUT
    const ApiURL = window.Links.ApiURL


    const [formInputs, setFormInputs] = useState({
        usercode: "",
        password: "",
        confirmpassword: "",
        skip_validation: false
    })

    const [formInputsUnlock, setFormInputsUnlock] = useState({
        usercode: "",
        userName: "",
    })


    const validationRules = {
        usercode: e => Text(e.target, 20, true, false, "upper", false),
        password: e => Text(e.target, 20, true, true, "any", false),
        confirmpassword: e => Text(e.target, 20, true, true, "any", false),
        skip_validation: e => e
    };


    const [menuCode, SetMenuCode] = useState("")
    const [show, setShow] = useState(false)
    const [AlertMsg, setAlertMsg] = useState('')
    const [AlertColor, setAlertColor] = useState('')

    const [disabled, setDisabled] = useState(false)

    const [saveEnable, setSaveEnable] = useState(true)
    const [deleteEnable, SetDeleteEnable] = useState(false)
    const [editEnable, SetEditEnable] = useState(false)
    const [Reason, setReason] = useState("Created")

    //Alert Parameter
    const [sweetAlertShow, setsweetAlertShow] = useState(false)
    const [AlertDescription, setAlertDescription] = useState(false)
    const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
    const [ErrorMsg, setErrorMsg] = useState('')
    const [addNew, SetAddNew] = useState(false)
    //*****Menu Rights Start*/
    const [menuAccess, SetMenuAccess] = useState(false)
    const [menuCreate, SetMenuCreate] = useState(false)
    const [menuDelete, SetMenuDelete] = useState(false)
    const [menuModify, SetMenuModify] = useState(false)
    const [menuPrint, SetMenuPrint] = useState(false)
    const [menuProcess, SetMenuProcess] = useState(false)
    const [menuName, SetMenuName] = useState("")
    const [parentName, SetParentName] = useState("")

    const [LocationCode, setLocationCode] = useState("")
    const [locationName, setLocationName] = useState("")
    const [LogUserType, setLogUserType] = useState("")
    const [LogCompanyCode, setLogCompanyCode] = useState("")
    const [userModelOpen, setUserModelOpen] = useState(false)
    const [unlockUserModelOpen, setUnlockUserModelOpen] = useState(false)


    const [loadingAlert, SetLoadingAlert] = useState(false)
    const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")


    //autocode generation related newly added code
    const [nullCode, setNullCode] = useState(false)
    const [autoCode, setAutoCode] = useState(false)

    //User Permission related usestates
    const [permissionAlertShow, setPermissionAlertShow] = useState(false)
    const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
    const [permissionReasonShow, setPermissionReasonShow] = useState(true)
    const [permissionName, setPermissionName] = useState("")
    const [permissionPassword, setPermissionPassword] = useState("")
    const [permissionNameDisable, setPermissionNameDisable] = useState(false)

    const [printoptionShow, setprintoptionShow] = useState(false)

    const [permissionGrantedAlertShow, setPermissionGrantedAlertShow] = useState(false)
    const [permissionGrantedAlertMsg, setPermissionGrantedAlertMsg] = useState("")
    const [permissionGrantedAlertColor, setPermissionGrantedAlertColor] = useState("")
    const [customActiveTab, setcustomActiveTab] = useState("1")

    //import from contexts
    const {
        isHeadOffice, getMenuDetails, masterAuditLog, getSelectedMasterPermissions, fetchAutoCode, passwordpolicy, passwordPolicyDescription
    } = useContext(Context);
    //import from contexts


    useEffect(async () => {

        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var LocationCode = obj[3]
        var LocationName = obj[4]
        var CompanyCode = obj[5]
        var menuDetail = await getMenuDetails(window.location.pathname)
        var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
        var parentname = menuDetail?.parentName
        SetParentName(parentname)
        setLocationCode(LocationCode)
        setLocationName(LocationName)
        setLogUserType(LogUserType)
        setLogCompanyCode(CompanyCode)

        var responseData = await getSelectedMasterPermissions(LogUserType, menu)

        SetMenuAccess(responseData.strMenuAccessRight)
        SetMenuCreate(responseData.strMenuCreateRight)
        SetMenuDelete(responseData.strMenuDeleteRight)
        SetMenuModify(responseData.strMenuModifyRight)
        SetMenuPrint(responseData.strMenuPrintRight)
        SetMenuProcess(responseData.strMenuProcessRight)
        SetMenuName(responseData.strMenuName)
        SetMenuCode(responseData.strMenuTag)
        setPermissionReasonShow(responseData.strMenuReasonShow)


        GetAutoCode(menu)

    }, [])


    // AuditLog
    useEffect(async () => {

        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var LocationCode = obj[3]
        var CompanyCode = obj[5]
        var menuDetail = await getMenuDetails(window.location.pathname)
        var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');

        await masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) //masterfile access log

    }, [])


    function userGetSelectedRow(e, row, isSelect, rowIndex) {
        setFormInputs({
            usercode: row.UH_ID,
            password: "",
            confirmpassword: "",
            skip_validation: false
        })
        validateUserCode(row.UH_ID)
        setUserModelOpen(false)
    }

    function unlockUserGetSelectedRow(e, row, isSelect, rowIndex) {
        setFormInputsUnlock({
            usercode: row.UH_ID,
            userName: ""
        })
        validateUserCode(row.UH_ID)
        setUnlockUserModelOpen(false)

    }


    function userModelTrigger() {
        setUserModelOpen(!userModelOpen)
    }

    function unlockUserModelTrigger() {
        setUnlockUserModelOpen(!unlockUserModelOpen)
    }

    //save button function
    const handlesave = async (e) => {

        //validate password policy
        if (customActiveTab == "1") {
            var password_pattern = new RegExp(passwordpolicy)

            if (formInputs.usercode == "") {
                displayAlertMessage("danger", "User Code is required")
                return
            }

            if (formInputs.password == "") {
                displayAlertMessage("danger", "Password is required")
                return
            }

            if (formInputs.confirmpassword == "") {
                displayAlertMessage("danger", "Confirm Password is required")
                return
            }

            if (formInputs.password != formInputs.confirmpassword) {
                displayAlertMessage("danger", "Password and Confirm Password should be same")
                return
            }

            if (!password_pattern.test(formInputs.password) && formInputs.skip_validation == false) {
                displayAlertMessage("danger", "Password Policy is not matched")
                return
            }


            try {
                SetLoadingAlert(true)
                SetLoadingAlerttitle("Updating Password...")
                const { isSuccess, data, error } = await Update_User_Password({
                    "userCode": formInputs.usercode,
                    "password": formInputs.password,
                    "logLocation": LocationCode,
                    "logUser": LogUserType,
                    "reason": Reason
                })
                SetLoadingAlert(false)

                if (isSuccess) {
                    displayAlertMessage("success", data)
                    ClearItem()

                } else {
                    displayAlertMessage("danger", error)
                }

            } catch (error) {
                SetLoadingAlert(false)
                console.log(error)
            }
        } else {

            if (formInputsUnlock.usercode == "") {
                displayAlertMessage("danger", "User Code is required")
                return
            }

            try {
                SetLoadingAlert(true)
                SetLoadingAlerttitle("Unlocking User...")
                const { isSuccess, data, error } = await Unlock_User({
                    "userCode": formInputsUnlock.usercode,
                    "password": "",
                    "logLocation": LocationCode,
                    "logUser": LogUserType,
                    "reason": Reason
                })
                SetLoadingAlert(false)

                if (isSuccess) {
                    displayAlertMessage("success", data)
                    ClearItem()

                } else {
                    displayAlertMessage("danger", error)
                }

            } catch (error) {
                SetLoadingAlert(false)
                console.log(error)
            }

        }



    }


    const validateUserCode = async (usercode) => {

        if (usercode == "") {
            setFormInputs({
                usercode: "",
                password: "",
                confirmpassword: "",
                skip_validation: false
            })

            setFormInputsUnlock({
                usercode: "",
                userName: ""
            })

            return false
        }

        try {
            SetLoadingAlert(true)
            SetLoadingAlerttitle("Validating User...")
            const { isSuccess, data, error } = await GetAllUserData(usercode)
            SetLoadingAlert(false)
            if (isSuccess) {
                if (customActiveTab == "2") {
                    setFormInputsUnlock({
                        usercode: data.strUserCode,
                        userName: data.strUserFullName
                    })
                }
                return true
            } else {
                displayAlertMessage("danger", error)
                setFormInputs({
                    usercode: "",
                    password: "",
                    confirmpassword: "",
                    skip_validation: false
                })

                setFormInputsUnlock({
                    usercode: "",
                    userName: ""
                })

                return false
            }
        } catch (error) {
            SetLoadingAlert(false)
        }
    }


    const toggleCustom = tab => {
        if (customActiveTab !== tab) {
            setcustomActiveTab(tab)
        }
    }


    //edit button function    
    const handleEdit = e => {
        setDisabled(false)
        setSaveEnable(true)
        SetDeleteEnable(true)
        SetEditEnable(false)

    }

    //new button function
    const handleNew = e => {
        // e.preventDefault()
        ClearItem();
        setShow(false)
        setSaveEnable(true)
    }

    //clear fields function    
    const ClearItem = () => {

        setDisabled(false)
        SetAddNew(false)
        setErrorMsg('')
        SetDeleteEnable(false)
        setNullCode(false)

        setReason("Created")
        SetEditEnable(false)
        setSaveEnable(true)
        setPermissionName("")
        setPermissionPassword("")
        setPermissionNameDisable(false)

        setFormInputs({
            usercode: "",
            password: "",
            confirmpassword: "",
            skip_validation: false
        })

        setFormInputsUnlock({
            usercode: "",
            userName: ""
        })

        setcustomActiveTab("1")

        GetAutoCode(menuCode)


    }

    //********Delete button function */
    const handleDelete = () => {
    }


    async function handlePrint(option) {

    }

    const PermissionHandle = (operation) => {

        const authToken = localStorage.getItem("authToken")
        const permissiondata = {
            "strUsername": permissionName,
            "strPassword": permissionPassword,
            "strLocation": LocationCode,
            "strMenuCode": menuCode
        }

        setPermissionName("")
        setPermissionPassword("")
        setReason("")


        fetch(`${ApiURL}login/userpermission`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authToken}`
                },
                body: JSON.stringify(permissiondata)
            }
        ).then(Response => {
            if (Response.status == "200") {
                Response.json()
                    .then(responseData => {
                        let Access = (responseData.data.strMenuAccessRight)
                        let Create = (responseData.data.strMenuCreateRight)
                        let Delete = (responseData.data.strMenuDeleteRight)
                        let Modify = (responseData.data.strMenuModifyRight)
                        let Print = (responseData.data.strMenuPrintRight)
                        let Process = (responseData.data.strMenuProcessRight)

                        if (operation == "Save") {
                            if (Create == true) {
                                handlesave()

                            } else if (Modify == true) {
                                handlesave()

                            } else {
                                if (operation == "Save" && addNew == true) {
                                    displayAlertMessage("danger", "This user dosen't have permission to save")
                                } else {
                                    displayAlertMessage("danger", "This user dosen't have permission to edit")
                                }
                            }
                        } else if (operation == "Delete") {
                            if (Delete == true) {
                                handleDelete()

                            } else {
                                displayAlertMessage("danger", "This user dosen't have permission to delete")
                            }
                        } else if (operation == "PDF") {
                            if (Print == true) {
                                handlePrint("PDF")

                            } else {
                                displayAlertMessage("danger", "This user dosen't have permission to print")
                            }
                        } else if (operation == "XCEL") {
                            if (Print == true) {
                                handlePrint("XCEL")

                            } else {
                                displayAlertMessage("danger", "This user dosen't have permission to print")
                            }
                        }
                    })

            } else if (Response.status == "400") {
                Response.json()
                    .then(responseData => {
                        setErrorMsg(responseData.msg)
                    })
                setDisabled(false)
                displayAlertMessage("danger", "Oops something went wrong !")
                setPermissionName("")
                setPermissionPassword("")


            } else if (Response.status == "403") {
                setDisabled(false)
                displayAlertMessage("danger", "You have not Permission to make changes !")
                setPermissionName("")
                setPermissionPassword("")

            } else if (Response.status == "404") {
                Response.json()
                    .then(responseData => {
                        setErrorMsg(responseData.msg)
                    })
                setDisabled(false)
                displayAlertMessage("danger", "Password or User Name is Invalid !")
                setPermissionName("")
                setPermissionPassword("")
            } else {
                ClearItem()
            }
        }).catch(error => {
            console.log(error.message)
        })

        setTimeout(() => {
            setShow(false)
        }, time)
    }


    async function GetAutoCode(menu) {

        var autoCodeRes = await fetchAutoCode(menu)

        if (autoCodeRes.nullCode == false) {
            setAutoCode(autoCodeRes.autoCode)
        } else {
            setNullCode(true)
            setAutoCode("")
        }

    }


    // Function for displaying Alert Messages.
    function displayAlertMessage(color, message) {
        setAlertColor(color)
        setAlertMsg(message)
        setShow(true)

        setTimeout(() => {
            setShow(false)
        }, time)
    }


    function formInputChange(e) {
        const { name, value } = e.target
        const validate = validationRules[name](e)
        setFormInputs({ ...formInputs, [name]: validate })
    }

    function formInputChangeUnlock(e) {
        const { name, value } = e.target
        setFormInputsUnlock({ ...formInputsUnlock, [name]: value })
    }


    const tabList = [
        {
            text: "Password Reset",
            icon: "fas fa-home",
            tabID: "1",
            onClick: () => {
                toggleCustom("1")
            },
        },
        {
            text: "Unlock User",
            icon: "far fa-user",
            tabID: "2",
            onClick: () => {
                toggleCustom("2")
            },
        }
    ]

    return (
        < React.Fragment >
            <div className="page-content">
                <MetaTags>
                    <title>{menuName}</title>
                </MetaTags>
                <Container fluid={true}>
                    <Breadcrumb title={parentName} breadcrumbItem={menuName}></Breadcrumb>
                    <DPAlert
                        confirm_both={sweetAlertShow}
                        title={menuName}
                        description={AlertDescription}
                        showCancel={true}
                        btnColor={"success"}
                        cancelColor={"danger"}
                        onConfirm={async () => {
                            setsweetAlertShow(false)
                            setPermissionName(LogUserType)
                            if (AlertConfirmOption == 1) {


                                if (addNew == true && menuCreate == true && permissionReasonShow == false) {
                                    handlesave()
                                } else if (addNew == true && menuCreate == true && permissionReasonShow == true) {
                                    setPermissionNameDisable(true)
                                    setPermissionAlertShow(true)
                                } else if (addNew == false && menuModify == true && permissionReasonShow == false) {
                                    handlesave()

                                } else if (addNew == false && menuModify == true && permissionReasonShow == true) {

                                    setPermissionNameDisable(true)
                                    setPermissionAlertShow(true)
                                } else {
                                    if (addNew == false) {

                                    }
                                    setPermissionName("")
                                    setPermissionReasonShow(true)
                                    setPermissionAlertShow(true)
                                }

                            } else if (AlertConfirmOption == 2) {
                                handleEdit()
                            } else if (AlertConfirmOption == 3) {
                                window.location.href = "/";
                            } else if (AlertConfirmOption == 4) {
                                handleNew()
                            } else if (AlertConfirmOption == 5) {

                                if (addNew == false && menuDelete == true && permissionReasonShow == false) {
                                    handleDelete()
                                } else if (addNew == false && menuDelete == true && permissionReasonShow == true) {
                                    setReason("")
                                    setPermissionNameDisable(true)
                                    setPermissionAlertShow(true)
                                } else {
                                    setReason("")
                                    setPermissionName("")
                                    setPermissionReasonShow(true)
                                    setPermissionAlertShow(true)
                                }
                            } else if (AlertConfirmOption == 6) {

                                if (menuPrint == true && permissionReasonShow == false) {
                                    setprintoptionShow(true)
                                } else if (menuPrint == true && permissionReasonShow == true) {
                                    setPermissionNameDisable(true)
                                    setPermissionAlertShow(true)
                                } else {
                                    setPermissionName("")
                                    setPermissionReasonShow(true)
                                    setPermissionAlertShow(true)
                                }
                            }

                        }}
                        onCancel={() => {
                            setsweetAlertShow(false)
                        }}
                    />
                    <DPPermission
                        confirm_both={permissionAlertShow}
                        title={menuName}
                        description={permissionAlertTitle}
                        showReason={permissionReasonShow}
                        nameDisable={false}//{permissionNameDisable}
                        showCancel={true}
                        btnColor={"success"}
                        cancelColor={"danger"}
                        AlName={permissionName}
                        show={permissionGrantedAlertShow}
                        AlertColor={permissionGrantedAlertColor}
                        AlertMsg={permissionGrantedAlertMsg}
                        AlNameOnchange={e => {
                            let val2 = Text(e.target, 50, true, false, "any", false)
                            setPermissionName(val2)
                        }}
                        AlPassward={permissionPassword}
                        AlPasswardOnchange={e => {
                            let val2 = Text(e.target, 50, true, true, "any", false)
                            setPermissionPassword(val2)
                        }}
                        AlReason={Reason}
                        AlReasonOnchange={e => {
                            let val2 = Text(e.target, 50, true, false, "any", true)
                            setReason(val2)
                        }}
                        onConfirm={() => {

                            setPermissionAlertShow(false)
                            if (AlertConfirmOption == 1) {
                                PermissionHandle("Save")
                            } else if (AlertConfirmOption == 5) {
                                PermissionHandle("Delete")
                            } else if (AlertConfirmOption == 6) {
                                setprintoptionShow(true)
                            }
                        }}
                        onCancel={() => {
                            setPermissionAlertShow(false)
                        }}
                    />
                    <DPPrintOption
                        confirm_both={printoptionShow}
                        title={menuName}
                        showCancel={true}
                        cancelColor={"danger"}
                        onConfirmpdf={() => {
                            handlePrint("PDF")
                            setprintoptionShow(false)
                        }}
                        onConfirmxcel={() => {
                            handlePrint("XCEL")
                            setprintoptionShow(false)
                        }}
                        onCancel={() => {
                            setprintoptionShow(false)
                        }}
                    />
                    <DPLoadingAlert
                        confirm_both={loadingAlert}
                        title={loadingAlertTitle}
                    />
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <DPTopToolBar
                                        //Help Button
                                        helpEnable={false}
                                        helpClick={() => {
                                            alert("Help")
                                        }}
                                        //Favorite Button
                                        favoriteEnable={false}
                                        favoriteClick={() => {
                                            alert("Favorite")
                                        }}
                                        //New Button
                                        newEnable={true}
                                        newClick={() => {
                                            setAlertDescription("Do you wish to refresh the screen ?");
                                            setAlertConfirmOption(4)
                                            setsweetAlertShow(true)
                                        }}
                                        //Save Button
                                        saveEnable={saveEnable}
                                        saveClick={() => {
                                            setAlertDescription("Do you wish to save ?");
                                            setAlertConfirmOption(1)
                                            setsweetAlertShow(true)
                                        }}
                                        //ProcessButton
                                        processEnable={false}
                                        processClick={() => {
                                            alert("Process")
                                        }}
                                        //Edit Button
                                        editEnable={editEnable && isHeadOffice}
                                        editClick={() => {
                                            setAlertDescription("Do you wish to edit ?");
                                            setAlertConfirmOption(2)
                                            setsweetAlertShow(true)
                                        }}
                                        //Print Button

                                        printEnable={false}
                                        printClick={() => {
                                            setReason("Printed")
                                            setAlertDescription("Do you wish to print ?");
                                            setAlertConfirmOption(6)
                                            setsweetAlertShow(true)
                                        }}
                                        //Delete Button
                                        deleteEnable={false}
                                        deleteClick={() => {
                                            setReason("Deleted")
                                            setAlertDescription("Do you wish to delete ?");
                                            setAlertConfirmOption(5)
                                            setsweetAlertShow(true)
                                        }}
                                        //Exit Button
                                        exitEnable={true}
                                        exitClick={() => {
                                            setAlertDescription("Do you wish to exit ?");
                                            setAlertConfirmOption(3)
                                            setsweetAlertShow(true)
                                        }}
                                    />

                                    <DPNavBar buttons={tabList} activeStatus={customActiveTab} />
                                    <Row>
                                        <TabContent activeTab={customActiveTab} className="p-3 text">
                                            {show ? (
                                                <Alert color={AlertColor} role="alert">
                                                    {AlertMsg}
                                                </Alert>
                                            ) : null}
                                            <TabPane tabId="1">
                                                <PasswordResetContent
                                                    menuName={menuName}
                                                    menuCode={menuCode}
                                                    formInputs={formInputs}
                                                    formInputChange={formInputChange}
                                                    userModelTrigger={userModelTrigger}
                                                    userModelOpen={userModelOpen}
                                                    userGetSelectedRow={userGetSelectedRow}
                                                    validateUserCode={validateUserCode}
                                                    switchOnchange={(e) => {
                                                        setFormInputs({ ...formInputs, skip_validation: e })
                                                    }}
                                                />
                                            </TabPane>
                                            <TabPane tabId="2">
                                                <UnlockUserContent
                                                    formInputChangeUnlock={formInputChangeUnlock}
                                                    formInputsUnlock={formInputsUnlock}
                                                    validateUserCode={validateUserCode}
                                                    unlockUserModelTrigger={unlockUserModelTrigger}
                                                    unlockUserGetSelectedRow={unlockUserGetSelectedRow}
                                                    unlockUserModelOpen={unlockUserModelOpen}
                                                    menuName={menuName}
                                                    menuCode={menuCode}
                                                />
                                            </TabPane>
                                        </TabContent>
                                    </Row>

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

        </React.Fragment >
    )

}

export default PasswordReset

